module.exports = __webpack_public_path__ + "static/media/Zocial.8d2b12ce.ttf";